<template>
    <div class="global_game_container">
        <div class="global_game_main">
            <div class="global_game_title">{{ $t('index.global_game_title') }}</div>
            <div class="global_game_desc">{{ $t('index.global_game_desc') }}</div>
            <div class="global_game_item_box">
                <!-- Line 1 -->
                <div class="global_game_item img-box" style="--t: 25s">
                    <div>
                        <div 
                            class="img-item-box" 
                            v-for="(item, index) in lineImg.line_1_1" :key="'line_1_1_' + index" 
                            @click="gotoGameDetail(item.game_id)">
                            <img :src="item.icon" alt="ICON" />
                        </div>
                    </div>

                    <div>
                        <div 
                            class="img-item-box" 
                            v-for="(item, index) in lineImg.line_1_2" :key="'line_1_2_' + index" 
                            @click="gotoGameDetail(item.game_id)">
                            <img :src="item.icon" alt="ICON" />
                        </div>
                    </div>
                </div>

                <!-- Line 2 -->
                <div class="global_game_item img-box" style="--t: 20s">
                    <div>
                        <div 
                            class="img-item-box" 
                            v-for="(item, index) in lineImg.line_2_1" :key="'line_2_1_' + index" 
                            @click="gotoGameDetail(item.game_id)">
                            <img :src="item.icon" alt="ICON" />
                        </div>
                    </div>

                    <div>
                        <div 
                            class="img-item-box" 
                            v-for="(item, index) in lineImg.line_2_2" :key="'line_2_2_' + index" 
                            @click="gotoGameDetail(item.game_id)">
                            <img :src="item.icon" alt="ICON" />
                        </div>
                    </div>
                </div>

                <!-- Line 3 -->
                <div class="global_game_item img-box" style="--t: 15s">
                    <div>
                        <div 
                            class="img-item-box" 
                            v-for="(item, index) in lineImg.line_3_1" :key="'line_3_1_' + index" 
                            @click="gotoGameDetail(item.game_id)">
                            <img :src="item.icon" alt="ICON" />
                        </div>
                    </div>

                    <div>
                        <div 
                            class="img-item-box" 
                            v-for="(item, index) in lineImg.line_3_2" :key="'line_3_2_' + index" 
                            @click="gotoGameDetail(item.game_id)">
                            <img :src="item.icon" alt="ICON" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="global_game_btn_box">
                <button @click="gotoAllGames">
                    {{ $t('index.btn_all_games') }} <img src="@/assets/static/imgs/common/arrow-white.png" alt="">
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { fetchAllGamesCached } from '@/api/gameDataLoader';

export default {
    name: 'GlobalGameMobile',
    data() {
        return {
            tips   : 'Hello World',
            lineImg: {
                line_1_1: [], line_1_2: [],
                line_2_1: [], line_2_2: [],
                line_3_1: [], line_3_2: []   
            }
        }
    },

    async mounted() {
        try {
            const games = await fetchAllGamesCached();
            this.lineImg.line_1_1 = this.$Common.getRandomItemsFromArray(games, 8);
            this.lineImg.line_1_2 = this.$Common.getRandomItemsFromArray(games, 8);
            this.lineImg.line_2_1 = this.$Common.getRandomItemsFromArray(games, 8);
            this.lineImg.line_2_2 = this.$Common.getRandomItemsFromArray(games, 8);
            this.lineImg.line_3_1 = this.$Common.getRandomItemsFromArray(games, 8);
            this.lineImg.line_3_2 = this.$Common.getRandomItemsFromArray(games, 8);
        } catch (err) {
            console.error('=== Mobile__GlobalGame__load failed >>>', err);
        }
    },

    methods: {
        // 跳转至全部游戏页
        gotoAllGames()
		{
			this.$router.push('/allgames');
		},

        // 跳转到游戏详情页
		gotoGameDetail(currentGameId)
		{
			// console.log('=== GlobalGame__gotoGameDetail__currentGameId >>>', currentGameId);
			let sign = this.$Common.makeSign(this, currentGameId);
			this.$router.push({
				path: `/gamedetail/${currentGameId}/${sign}`
			});
		}
    }
}
</script>

<style lang="less" scoped>
.global_game_container{
	display:flex;justify-content:center;align-items:flex-start;
	width:var(--com-base-container-wm);height:var(--com-base-top-container-h3);
	background:linear-gradient(135deg, rgb(244, 247, 252), rgb(242, 245, 250), rgba(245, 249, 253), rgba(251, 251, 253, 1));
    .global_game_main{
        margin:0 auto;padding-top:75px;
        width:var(--com-base-container-wm);height:inherit;
        /* background:#CCC; */
        .global_game_title{
            height:50px;line-height:50px;
            font-size:var(--com-base-fz-58);font-weight:bold;color:var(--com-main-ft-color);text-align:center;
        }
        .global_game_desc{
            height:80px;line-height:80px;
            font-size:var(--com-base-fz-28);font-weight:normal;color:#676D77;text-align:center;
        }
        .global_game_item_box{
            margin:0 auto;margin-top:0px;padding:40px;
            width:var(--com-base-container-wm);height:500px;
            display:flex;flex-direction:column;justify-content:space-between;align-items:center;
            gap:10px;
            background:transparent;
            .global_game_item{
                width:var(--com-base-container-wm);height:130px;
                display:flex;
                overflow:hidden;
                mask-image:linear-gradient(90deg, transparent, #fff 20%, #fff 80%, transparent);
                -webkit-mask-image:linear-gradient(90deg, transparent, #fff 20%, #fff 80%, transparent);
            }
            .global_game_item > div{
                white-space:nowrap;
                animation:animate var(--t) linear infinite;
                animation-delay:calc(var(--t) * -1);
                display:flex;
            }
            @keyframes animate{
                0%{
                    transform:translateX(100%);
                }
                100%{
                    transform:translateX(-100%);
                }
            }
            .global_game_item > div:nth-child(2){
                animation:animate2 var(--t) linear infinite;
                animation-delay:calc(var(--t) / -2);
            }
            @keyframes animate2{
                0%{
                    transform:translateX(0);
                }
                100%{
                    transform:translateX(-200%);
                }
            }
            .global_game_item:hover > div{
                animation-play-state:paused;
            }
            .img-box{
                .img-item-box{
                    position:relative;
                    width:130px;height:130px;
                    border-radius:25px;
                    margin-right:15px;
                    img{
                        width:inherit;height:inherit;
                        border-radius:inherit;
                        cursor:pointer;
                        z-index:1;
                        /* transition:filter 0.5s;
                        filter:grayscale(0.9); */
                    }
                    .mask_enter{
                        display:none;
                        position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;
                        width:inherit;height:inherit;line-height:130px;
                        border-radius:inherit;
                        background:rgba(0, 0, 0, .7);
                        font-size:var(--com-base-fz-16);color:rgba(255, 255, 255, 0.85);text-align:center;font-weight:bold;
                        cursor:pointer;
                        z-index:2;
                    }
                    .active{
                        display:block;
                    }
                }
            }
        }

        .global_game_btn_box{
            display:flex;justify-content:center;align-items:center;
            margin-top:60px;
            button{
                width:310px;height:88px;
                background:#1D55FF;border-radius:44px;border:none;outline:none;
                font-size:var(--com-base-fz-28);color:#FFF;text-align:center;font-weight:bold;
                cursor:pointer;
                img{
                    width:28px;height:24px;
                }
            }
        }
    }
}
</style>
